module.exports = __webpack_public_path__ + "img/خلاق.1040dc60.jpg";